import {
  Dialog,
  DialogContent,
  Grid,
  Typography,
  IconButton,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useState, forwardRef } from "react";
import { useQuery } from "@tanstack/react-query";
import HttpService from "../services/HttpService";
import CircularProgress from "@mui/material/CircularProgress";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import CloseIcon from "@mui/icons-material/Close";
import { Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import PanView from "./PanView";
import Labels from "../labels/Labels";

export default function SecureInfoCardDetail(props) {
  const { idBundleDetail } = props;
  const [dialogTitlePostMessage, setDialogTitlePostMessage] = useState("");
  const [isLoadingPanInfo, setIsLoadingPanInfo] = useState(false);

  async function fetchPaycardDetail() {
    const response = await HttpService.getAxiosClient().get(
      window.API_URL + `/paycards/` + idBundleDetail
    );
    return response;
  }

  const { isError: isErrorPaycardDetail, isFetching: isFetchingPayCardDetail } =
    useQuery({
      queryKey: ["paycardDetail"],
      queryFn: fetchPaycardDetail,
      refetchOnWindowFocus: false,
    });

  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={10} ref={ref} variant="filled" {...props} />;
  });

  const handleFeedbackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setFeedback({ open: false, type: "error", message: "" });
  };

  const [feedback, setFeedback] = useState({
    open: false,
    type: "error",
    message: "",
  });

  const handleClose = (event, reason) => {
    if (reason === "backdropClick") return; //avoid closing the modal by clicking the backdrop
    props.setOpen(false);
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      disableEscapeKeyDown={true}
    >
      <Box sx={{ width: "600px", height: "500px" }}>
        {isFetchingPayCardDetail ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <CircularProgress color="inherit" />
          </div>
        ) : isErrorPaycardDetail ? (
          <h4>
            {Labels.getLabel(
              "secureInfoCardDetail.errorGettingInfo",
              "There was an error getting the info"
            )}
          </h4>
        ) : (
          <>
            <Box
              sx={{
                backgroundColor: "primary.main",
                px: 3,
                minHeight: 52,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                {isLoadingPanInfo ? (
                  <CircularProgress size={20} sx={{ color: "white" }} />
                ) : (
                  <CreditCardIcon sx={{ color: "white" }} />
                )}
                <Typography variant="h6" sx={{ color: "white" }}>
                  {props.dialogTitle}
                  {dialogTitlePostMessage && (
                    <Typography
                      component="span"
                      fontSize={"0.9rem"}
                      sx={{ marginLeft: 2, color: "white" }}
                    >
                      {dialogTitlePostMessage}
                    </Typography>
                  )}
                </Typography>
              </Box>
              <IconButton onClick={handleClose} sx={{ color: "white" }}>
                <CloseIcon />
              </IconButton>
            </Box>
            <DialogContent sx={{ paddingTop: 3 }}>
              <Grid container spacing={1.5}>
                <Grid container spacing={1.5}>
                  <PanView
                    onTimeout={props.setOpen}
                    memberId={props.memberId}
                    companyId={props.companyId}
                    setDialogTitlePostMessage={setDialogTitlePostMessage}
                    setIsLoadingPanInfo={setIsLoadingPanInfo}
                  />
                </Grid>
              </Grid>
            </DialogContent>
          </>
        )}
      </Box>
      <Snackbar
        open={feedback.open}
        autoHideDuration={6000}
        onClose={feedback.onClose ? feedback.onClose : handleFeedbackClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={feedback.onClose ? feedback.onClose : handleFeedbackClose}
          severity={feedback.type}
          sx={{ width: "100%" }}
        >
          {feedback.message}
        </Alert>
      </Snackbar>
    </Dialog>
  );
}
